import { State } from "../../types";
import { sortValueKeys } from "../util";

export type MoveToPrevDataPointAction = Readonly<{
  type: "MOVE TO PREV DATA POINT";
}>;

export const moveToPrevDataPoint = (state: State, _action: MoveToPrevDataPointAction): State => {
  const sortedKeys = sortValueKeys(
    Object.keys(state.values),
    state.taxonomy,
  );
  const index = sortedKeys.indexOf(state.activeValue);

  if (index === 0) {
    return state;
  } else if (index < 0) {
    return {
      ...state,
      activeValue: sortedKeys[sortedKeys.length - 1],
    };
  }
  return {
    ...state,
    activeValue: sortedKeys[index - 1],
  };
};
